export function cursoActualizarMonedasNormalize(row) {
  return {
    idCurso: row.idCurso ?? row.IdCurso ?? row['IdCurso'] ?? 0,
    monedasNueva: row.monedasNueva ?? row.MonedasNueva ?? row['MonedasNueva'] ?? 0,
  };
}
